import { graphql } from "babel-plugin-relay/macro";
import React, { useEffect } from "react";
import { useFragment } from "react-relay";
import { RightFrameContentElement_ContentSubmissionFragment$key } from "@generated/RightFrameContentElement_ContentSubmissionFragment.graphql";
import { RightFrameMultipleChoiceElementPart } from "./RightFrameMultipleChoiceElementPart";
import { FileElementPart } from "../../../infecto-lms-webapp/components/content-element/file/FileElementPart.component";
import { PodcastElementPart } from "../../../infecto-lms-webapp/components/content-element/podcast/PodcastElementPart.component";
import { TextElementPart } from "../../../infecto-lms-webapp/components/content-element/text/TextElementPart.component";
import { VideoElementPart } from "../../../infecto-lms-webapp/components/content-element/video/VideoElementPart.component";

const CONTENT_SUBMISSION_FRAGMENT = graphql`
	fragment RightFrameContentElement_ContentSubmissionFragment on ContentSubmission {
		definition {
			... on ActiveELearningContentSubmissionDefinition {
				currentElementState {
					element {
						elementType
					}
				}
			}
		}
		...FileElementPart_ContentSubmissionFragment
		...RightFrameMultipleChoiceElementPart_ContentSubmissionFragment
		...PodcastElementPart_ContentSubmissionFragment
		...TextElementPart_ContentSubmissionFragment
		...VideoElementPart_ContentSubmissionFragment
	}
`;

interface OwnProps {
	contentSubmissionFragmentRef: RightFrameContentElement_ContentSubmissionFragment$key;
	scrollRef?: React.RefObject<HTMLDivElement>;
	scrollOnReady?: boolean;
}

export function RightFrameContentElement({
	contentSubmissionFragmentRef,
	scrollRef,
	scrollOnReady,
}: OwnProps) {
	const contentSubmission = useFragment<RightFrameContentElement_ContentSubmissionFragment$key>(
		CONTENT_SUBMISSION_FRAGMENT,
		contentSubmissionFragmentRef,
	);
	const elementType = contentSubmission.definition.currentElementState?.element.elementType;

	useEffect(() => {
		if (!scrollOnReady) return;
		if (elementType !== "multipleChoice") return;
		if (!scrollRef?.current) return;
		console.log("scrollonready", scrollOnReady);
		requestAnimationFrame(() => {
			scrollRef.current?.scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		});
	}, [scrollOnReady, elementType, scrollRef]);
	switch (contentSubmission.definition.currentElementState?.element.elementType) {
		case "file":
			return <FileElementPart contentSubmissionFragmentRef={contentSubmission} />;
		case "multipleChoice":
			return (
				<div ref={scrollRef}>
					<RightFrameMultipleChoiceElementPart contentSubmissionFragmentRef={contentSubmission} />
				</div>
			);
		case "podcast":
			return <PodcastElementPart contentSubmissionFragmentRef={contentSubmission} />;
		case "text":
			return <TextElementPart contentSubmissionFragmentRef={contentSubmission} />;
		case "video":
			return <VideoElementPart contentSubmissionFragmentRef={contentSubmission} />;
		default:
			return (
				<div>
					Unbekannter Elementtyp:{" "}
					{contentSubmission.definition.currentElementState?.element.elementType}
				</div>
			);
	}
}
